// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Np92","label":"Radio_label__JxoMR","checkMark":"Radio_checkMark__3McBZ","disabled":"Radio_disabled__1mSE-"};